export default "__VITE_ASSET__78ef052a__"